var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 329,
    viewBox: "0 0 86 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-222.023 328.206C-203.108 304.818 -198.989 301.111 -179.58 286.295C-174.826 282.665 -165.582 276.953 -154.164 271.498C-150.747 269.863 -147.359 268.381 -144.018 267.022C-120.111 257.328 -93.3281 255.959 -66.8772 258.212C0.611878 263.962 61.5238 227.43 79.2811 172.119C97.0764 116.703 67.8163 55.1862 22.156 25.1643C16.2148 21.2583 -11.8211 4.0283 -42.5808 1.48133C-139.7 -6.58724 -178.508 87.489 -207.892 230.632C-208.461 233.417 -210.634 246.674 -211.023 249.488L-222.023 328.215L-222.023 328.206Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector11);
export default __webpack_public_path__ + "static/media/vector1-1.3ae6c91907c746f0e3ceb1124defbff7.svg";
export { ForwardRef as ReactComponent };